// Plan v7 / Day 24 F6 — 5 locale UI config.
// Used by language switcher (F7) and useLocale hook.

export type AppLocale = 'tr' | 'en' | 'ar' | 'es' | 'ru';

export const APP_LOCALES: readonly AppLocale[] = ['tr', 'en', 'ar', 'es', 'ru'] as const;

export const DEFAULT_LOCALE: AppLocale = 'tr';

export const RTL_LOCALES: readonly AppLocale[] = ['ar'] as const;

interface LocaleMeta {
  code: AppLocale;
  flag: string;       // Emoji flag (display only)
  label: string;      // Native label
  englishLabel: string; // English label (for ARIA, debug)
}

export const LOCALE_META: Record<AppLocale, LocaleMeta> = {
  tr: { code: 'tr', flag: '🇹🇷', label: 'Türkçe',  englishLabel: 'Turkish' },
  en: { code: 'en', flag: '🇬🇧', label: 'English', englishLabel: 'English' },
  ar: { code: 'ar', flag: '🇸🇦', label: 'العربية', englishLabel: 'Arabic' },
  es: { code: 'es', flag: '🇪🇸', label: 'Español', englishLabel: 'Spanish' },
  ru: { code: 'ru', flag: '🇷🇺', label: 'Русский', englishLabel: 'Russian' },
};

export function isAppLocale(value: unknown): value is AppLocale {
  return typeof value === 'string' && APP_LOCALES.includes(value as AppLocale);
}

export function isRtl(locale: AppLocale): boolean {
  return RTL_LOCALES.includes(locale);
}
